import React from 'react';
import { BetHistoryContainer, BetHistoryFilterTypes, betStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { BetHistoryItem } from './betHistoryItem';

export const BetHistoryWrapper = observer(() => {
  const { Win, Lose, All } = BetHistoryFilterTypes;

  const betHistoryParser = (betHistory) => {
    const { betHistoryFilter } = betStore;
    switch (betHistoryFilter) {
      case Win: {
        return betHistory.map((bet) => {
          return {
            ...bet,
            additionalParams: (bet.additionalParams || bet?.betData).filter(
              (bet) => bet?.winAmount
            ),
          };
        });
      }
      case Lose: {
        return betHistory.map((bet) => {
          return {
            ...bet,
            additionalParams: (bet.additionalParams || bet?.betData).filter(
              (bet) => !bet?.winAmount
            ),
          };
        });
      }
      case All:
        return betHistory;
      default:
        return betHistory;
    }
  };

  return (
    <BetHistoryContainer
      isGetViaSocket
      renderBetHistoryItem={(bet, index) => (
        <BetHistoryItem bet={bet} key={bet?.id} index={index} />
      )}
      filterNames={[All, Win, Lose]}
      customBetHistoryParser={(betHistory) => betHistoryParser(betHistory)}
      customStatus={null}
    />
  );
});
